<h2 mat-dialog-title [ngClass]="message?.class_name">{{ message?.title }}</h2>
<mat-dialog-content [innerHTML]="message?.message"></mat-dialog-content>
<mat-dialog-actions align="end">
  @if (!message?.class_name) {
    <button
      mat-button
      class="btn btn-pink"
      [mat-dialog-close]="true"
      id="dialog-info-ok-button"
      >
      Ok, got it.
    </button>
  }
  @if (message?.class_name && !message?.is_close) {
    <button
      mat-button
      class="btn btn-pink"
      [mat-dialog-close]="true"
      id="dialog-info-okay-button"
      >
      Okay
    </button>
  }
  @if (message?.is_close) {
    <button
      mat-button
      class="btn btn-pink"
      [mat-dialog-close]="true"
      id="dialog-info-close-button"
      >
      Close
    </button>
  }
</mat-dialog-actions>
